export default __webpack_public_path__ + "static/media/risk-bars-moderate-light.6cab8090.svg";